'use client'

import type { CSSProperties } from 'react'
import type { FishingWorldActiveEvent } from '@/lib/fishing-world-scheduler'
import { createMicroLifePresentation } from '@/lib/fishing-world-anchors'
import { eventNumber, useAmbientEventCompletion } from './ambient-rendering'
import styles from './FishingScene.module.css'

interface AmbientFishProps {
  event?: FishingWorldActiveEvent
  onComplete?: (eventId: string) => void
}

export function AmbientFish({ event, onComplete }: AmbientFishProps) {
  useAmbientEventCompletion(event, onComplete)
  if (!event) return null

  const placement = event.presentation?.placement ?? createMicroLifePresentation(event.kind, event.id)
  if (!placement) return null
  const position = {
    '--fish-x': `${placement.center.x * 100}%`,
    '--fish-y': `${placement.center.y * 100}%`,
    '--fish-scale': placement.spriteScale,
  } as CSSProperties

  return (
    <div className={styles.ambientFishEvent} style={position} data-testid="ambient-fish" aria-hidden="true">
      <i className={styles.ambientFishSprite} data-kind={eventNumber(event, 3) > 0.5 ? 0 : 1} data-half="0" />
      <i className={styles.ambientFishSprite} data-kind={eventNumber(event, 3) > 0.5 ? 0 : 1} data-half="1" />
      <span className={styles.ambientFishRipple}><i /><i /><i /></span>
    </div>
  )
}
